import { Box, type SxProps, type Theme } from '@mui/material';

import { brand } from '@/theme/brand';

export interface WordmarkProps {
  size?: number;
  /** Renders on a dark surface. */
  inverted?: boolean;
  sx?: SxProps<Theme>;
}

/**
 * The product mark — a quiet typographic wordmark in ink.
 * Swaps out for an SVG the moment `brand.logoSvg` is filled in.
 */
export function Wordmark({ size = 20, inverted = false, sx }: WordmarkProps) {
  const { text, weight, letterSpacing } = brand.wordmark;

  if (brand.logoSvg) {
    return (
      <Box
        sx={{ display: 'inline-flex', height: size * 1.4, ...sx }}
        dangerouslySetInnerHTML={{ __html: brand.logoSvg }}
      />
    );
  }

  return (
    <Box
      component="span"
      sx={{
        fontFamily: brand.fontFamily,
        fontSize: size,
        fontWeight: weight,
        letterSpacing,
        lineHeight: 1,
        userSelect: 'none',
        whiteSpace: 'nowrap',
        color: inverted ? brand.palette.paper : brand.palette.ink,
        ...sx,
      }}
    >
      {text}
    </Box>
  );
}
